import { brand } from '../config/brand';

/**
 * Floating WhatsApp action button — fixed bottom-right.
 * Standard pattern on Spanish health/wellness sites.
 */
export function WhatsAppFab() {
  if (!('whatsapp' in brand.contact)) return null;

  return (
    <a
      href={brand.contact.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-fab"
      aria-label="WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="32" height="32" fill="#fff" aria-hidden="true">
        <path d="M16.004 2.667A13.24 13.24 0 0 0 2.763 15.91a13.14 13.14 0 0 0 1.798 6.627L2.667 29.333l7.005-1.838A13.24 13.24 0 0 0 16.004 29.3 13.32 13.32 0 1 0 16.004 2.667Zm0 24.28a10.88 10.88 0 0 1-5.55-1.516l-.398-.237-4.125 1.082 1.1-4.02-.26-.413A10.92 10.92 0 1 1 16.004 26.947Zm5.984-8.176c-.328-.164-1.94-.957-2.241-1.067-.301-.109-.52-.164-.74.164s-.848 1.067-1.04 1.285-.383.246-.711.082a8.96 8.96 0 0 1-2.638-1.629 9.89 9.89 0 0 1-1.825-2.274c-.191-.328-.02-.506.144-.67.147-.147.328-.383.492-.574.164-.191.219-.328.328-.547.11-.219.055-.41-.027-.574s-.739-1.784-1.012-2.441c-.267-.642-.538-.555-.739-.565l-.629-.011a1.21 1.21 0 0 0-.875.41 3.68 3.68 0 0 0-1.148 2.735 6.38 6.38 0 0 0 1.34 3.392 14.63 14.63 0 0 0 5.601 4.953c.783.338 1.394.54 1.87.691a4.5 4.5 0 0 0 2.067.13c.63-.094 1.94-.793 2.214-1.559.273-.765.273-1.422.191-1.559-.082-.136-.301-.219-.629-.383Z" />
      </svg>
    </a>
  );
}
